export default {
  settings: 'Настройки',
  general: 'Общее',
  organization: 'Организация',
  billing: 'Платежи',
  aiIntegrations: 'AI-интеграции',
  aiIntegrationsTitle: 'AI-интеграции',
  aiIntegrationsDescription:
    'Подключайте внешних AI-ассистентов к контексту вашего Laplace.',

  // General
  generalTitle: 'Общее',
  generalDescription: 'Управление настройками интерфейса.',
  profile: 'Профиль',
  profileDescription: 'Измените имя и email аккаунта.',
  profileUpdated: 'Профиль обновлён',
  profileUpdateFailed: 'Не удалось обновить профиль',
  name: 'Имя',
  namePlaceholder: 'Иван Иванов',
  nameRequired: 'Укажите имя.',
  nameTooLong: 'Имя должно быть не длиннее 120 символов.',
  email: 'Email',
  emailChangeHint:
    'Мы отправим ссылку для подтверждения на новый email. Текущий email работает, пока вы её не откроете.',
  emailChangePending:
    'Мы отправили ссылку для подтверждения на {{email}}. Текущий email работает, пока вы её не откроете.',
  emailChangeResend: 'Отправить ещё раз',
  emailChangeCancel: 'Отменить смену',
  emailChangeSent: 'Ссылка для подтверждения отправлена',
  emailChangeCancelled: 'Смена email отменена',
  emailChangeInvalidEmail: 'Введите корректный email.',
  emailChangeInUse: 'Этот email уже используется другим аккаунтом.',
  emailChangeUnchanged: 'Это уже ваш email.',
  emailChangeSendFailed: 'Не удалось отправить письмо. Попробуйте ещё раз.',
  emailChangeFailed: 'Не удалось начать смену email. Попробуйте ещё раз.',
  passwordSecurity: 'Пароль',
  passwordSecurityDescription:
    'Смените пароль аккаунта после проверки текущего пароля.',
  currentPassword: 'Текущий пароль',
  newPassword: 'Новый пароль',
  confirmNewPassword: 'Подтвердите новый пароль',
  passwordRules:
    'Пароль должен содержать от 8 до 50 символов, заглавные и строчные буквы, цифру и спецсимвол.',
  passwordMinLength: 'Пароль должен быть не короче 8 символов.',
  passwordTooLong: 'Пароль должен быть не длиннее 50 символов.',
  passwordPolicy:
    'Пароль должен содержать от 8 до 50 символов, заглавные и строчные буквы, цифру и спецсимвол.',
  passwordConfirmationMismatch: 'Пароли не совпадают.',
  currentPasswordInvalid: 'Текущий пароль указан неверно.',
  passwordReused: 'Нельзя использовать текущий или один из последних паролей.',
  passwordChanged: 'Пароль изменён',
  passwordChangeFailed: 'Не удалось изменить пароль',
  passwordRateLimited: 'Слишком много попыток. Попробуйте позже.',
  showPassword: 'Показать пароль',
  hidePassword: 'Скрыть пароль',
  language: 'Язык',
  languageDescription: 'Выберите язык интерфейса.',
  languageEn: 'English',
  languageRu: 'Русский',
  appearance: 'Оформление',
  appearanceDescription: 'Выберите, как выглядит приложение.',
  themeLight: 'Светлая',
  themeLightDesc: 'Стандартная светлая тема с полным контрастом и яркостью.',
  themeDark: 'Тёмная',
  themeDarkDesc:
    'Стандартная тёмная тема для комфортной работы при слабом освещении.',
  themeSystem: 'Системная',
  themeSystemDesc:
    'Автоматически переключается между светлой и тёмной темой в зависимости от настроек системы.',
  codingIntegrations: 'Интеграции для разработки',
  codingIntegrationsDescription:
    'Используйте контекст Laplace в Codex, Claude Code и других MCP-клиентах.',
  mcpDescription:
    'Персональное подключение только для чтения доступных вам воркспейсов и чатов.',
  mcpLoading: 'Загрузка адреса…',
  mcpCopy: 'Скопировать адрес',
  mcpCopied: 'Скопировано',
  mcpServerAddress: 'Адрес для подключения',
  mcpConnectedCount_one: '{{count}} подключение',
  mcpConnectedCount_few: '{{count}} подключения',
  mcpConnectedCount_many: '{{count}} подключений',
  mcpStepCopyTitle: 'Скопируйте адрес',
  mcpStepCopyDescription:
    'Он одинаков для Codex, Claude Code и других клиентов.',
  mcpStepAddTitle: 'Добавьте в AI-ассистент',
  mcpStepAddDescription: 'Выберите remote MCP server и вставьте адрес Laplace.',
  mcpStepApproveTitle: 'Подтвердите доступ',
  mcpStepApproveDescription:
    'Laplace откроется и попросит разрешение от вашего имени.',
  mcpReadOnlyNotice:
    'Только чтение доступного вам контекста. Секреты интеграций не передаются.',
  mcpSetupHint:
    'Добавьте этот URL как remote MCP server. Coding-agent откроет Laplace для авторизации.',
  mcpConnectedClients: 'Подключённые клиенты',
  mcpConnectedClientsDescription:
    'AI-ассистенты, которым вы разрешили использовать контекст Laplace.',
  mcpNoConnections: 'Пока нет подключений',
  mcpNoConnectionsHint:
    'Первый клиент появится здесь после подтверждения доступа.',
  mcpLastUsed: 'Последнее использование: {{date}}',
  mcpNeverUsed: 'Ещё не использовалось',
  mcpRevoke: 'Отозвать подключение',
  mcpRevoked: 'Подключение отозвано',
  mcpRevokeFailed: 'Не удалось отозвать подключение',
  mcpLoadFailed: 'Не удалось загрузить AI-интеграции',
  mcpRetry: 'Повторить',
  mcpAuthorizeTitle: 'Подключить {{client}}?',
  mcpAuthorizeDescription:
    'Клиент получит доступ только для чтения к тем же данным Laplace, которые доступны вам. Секреты и токены интеграций не передаются.',
  mcpAuthorize: 'Разрешить и продолжить',
  mcpDeny: 'Отклонить',
  mcpAuthorizationFailed:
    'Не удалось завершить авторизацию. Попробуйте ещё раз.',
  deleteAccount: 'Удаление аккаунта',
  deleteAccountDescription: 'Это действие нельзя отменить.',
  deleteAccountButton: 'Удалить аккаунт',
  deleteAccountConfirmTitle: 'Удалить аккаунт?',
  deleteAccountConfirmDescription:
    'Аккаунт будет удалён без возможности восстановления.',
  deleteAccountConfirmInputLabel:
    'Введите свою почту, чтобы подтвердить удаление.',
  deleteAccountConfirmButton: 'Удалить навсегда',
  deleteAccountSuccess: 'Аккаунт удалён',
  deleteAccountFailed: 'Не удалось удалить аккаунт',
  adminSuccessionTitle: 'Нужно передать управление воркспейсами',
  adminSuccessionDescription:
    'В этих воркспейсах вы последний админ. Выберите нового админа.',
  adminSuccessionSelectAdmin: 'Выберите нового админа',
  adminSuccessionNoCandidates: 'В воркспейсе нет других участников.',
  adminSuccessionWillDelete: 'Будет удалён',
  adminSuccessionSelectPlaceholder: 'Новый админ',
  adminSuccessionLoading: 'Проверяем воркспейсы...',
  adminSuccessionLoadFailed: 'Не удалось проверить воркспейсы.',

  // Billing
  billingTitle: 'Платежи',
  billingDescription: 'Просмотр текущей подписки и управление планом.',
  loadingBilling: 'Загрузка данных биллинга...',
}
